<template>
    <div id="fabric-js-container" ref="fabricJSContainer">
        <canvas id="fabric-js-canvas" class="workspace-module-container" ref="fabricJS"></canvas>
    </div>
</template>

<script>
    import {urlForFileStorage} from "../common";
    import {fabricEditor} from "../../fabric/fabricMain";
    import {bus} from "../../vue_bus";
    import {threeMain} from "../../threeJS/threeMain";
    import {getScale, getNormalizeScale} from "../../fabric/libs/common";

    export default {
        name: "WorkspaceFabric.vue",
        mixins: [urlForFileStorage],
        mounted() {
            this.initFabric();

            bus.$on("unSelectedPlaneFromPlaneVisualisator", (planeID) => {
                this.$router.push({
                  name: "designListSelected",
                }).catch(() => {
                });
            });

            bus.$on("selectedPlaneFromPlaneVisualisator", (planeID) => {
                if (planeID === this.$route.params.planeID)
                    return;

                const plane = this.$store.getters["active/PLANE_BY_ID"](planeID);

                if(!plane || !plane.idDesignGroup || !plane.type)
                    return;

                this.$router.push({
                    name: "designMaterialsSelectedGroup",
                    params: {groupID: plane.idDesignGroup, facadeElement: plane.type}
                }).catch(() => {
                });
            })

        },
      beforeDestroy() {
        let params = Object.assign({}, this.$route.params);
        delete params.view;
        this.$router.replace({ params }).catch(()=>{});
      },
      destroyed() {
            bus.$off("selectedPlaneFromPlaneVisualisator");
            bus.$off("unSelectedPlaneFromPlaneVisualisator");
            this.editor.destroy();
        },
        computed: {
            activePhotoAbsoluteURL() {
                return this.urlForFileStorage(this.$store.getters[`active/GET_ACTIVE_PHOTO`].src);
            },
            activeDesign() {
                return this.$route.params.designID;
            },
        },
        watch: {
            activeDesign() {
                this.editor.destroy();
                this.initFabric();
            },
        },
        methods: {
            initFabric: async function () {
              let renderPromise = new Promise(async (resolve, reject)=>{
                this.editor = new fabricEditor(this.$refs["fabricJS"]);
                this.editor.updateCanvaSize({
                      width: this.$refs["fabricJSContainer"].offsetWidth,
                      height: this.$refs["fabricJSContainer"].offsetHeight
                    }
                );
                let size = await this.$store.dispatch("active/GET_ACTIVE_IMG_SIZE");
                this.scale = getNormalizeScale(size, this.editor.fabricJS);
                const sourceImg = await this.editor.addSourceImage(this.activePhotoAbsoluteURL, this.scale);
                this.editor.showPlanes({withTexture: true, scale: this.scale}).then(
                    ()=>{
                      // this.editor.setViewport(sourceImg, this.scale)
                      resolve(true);
                    }
                ).catch((err) => {
                    reject(err)
                });
                this.editor.setViewport(sourceImg, this.scale);
              })
              this.editor.setQuality("high");
              this.$store.dispatch("IN_PROGRESS", renderPromise);
              // await renderPromise
              // this.$store.commit("IN_PROGRESS", null);
              // this.$store.commit("PROGRESS_PERCENT", 100);

              // this.editor.setViewport(sourceImg, this.scale)
            }
        }
    }
</script>

<style scoped>
    #fabric-js-container {
        width: 100%;
        height: 100%;
    }
</style>
